"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToolbarButtonStyles_unstable", {
    enumerable: true,
    get: function() {
        return useToolbarButtonStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactbutton = require("@fluentui/react-button");
const useBaseStyles = /*#__PURE__*/ (0, _react.__styles)({
    vertical: {
        Beiy3e4: "f1vx9l62"
    },
    verticalIcon: {
        Be2twd7: "f1rt2boy",
        B6of3ja: "f1hu3pq6",
        t21cq0: [
            "f11qmguv",
            "f1tyq0we"
        ],
        jrapky: "f19f4twv",
        Frg6f3: [
            "f1tyq0we",
            "f11qmguv"
        ]
    }
}, {
    d: [
        ".f1vx9l62{flex-direction:column;}",
        ".f1rt2boy{font-size:24px;}",
        ".f1hu3pq6{margin-top:0;}",
        ".f11qmguv{margin-right:0;}",
        ".f1tyq0we{margin-left:0;}",
        ".f19f4twv{margin-bottom:0;}"
    ]
});
const useToolbarButtonStyles_unstable = (state)=>{
    (0, _reactbutton.useButtonStyles_unstable)(state);
    const buttonStyles = useBaseStyles();
    state.root.className = (0, _react.mergeClasses)(state.root.className, state.vertical && buttonStyles.vertical);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(state.icon.className, state.vertical && buttonStyles.verticalIcon);
    }
}; //# sourceMappingURL=useToolbarButtonStyles.styles.js.map
